import { ActionButton, PrimaryButton, Stack } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

/** All the buttons for things like saving and reverting*/
export const PickerActionBar = ({
  saveChanges,
  hasChanges,
  isEndBeforeStart,
  isMoreThanOneYear,
  clear,
  resetToDefault,
}: {
  saveChanges: () => void;
  hasChanges: boolean | undefined;
  isEndBeforeStart: boolean | undefined;
  isMoreThanOneYear: boolean;
  clear: () => void;
  resetToDefault: () => void;
}) => {
  const [t] = useTranslation(['search', 'translation']);
  return (
    <Stack horizontal wrap verticalAlign='stretch'>
      <PrimaryButton
        {...{
          onClick: saveChanges,
          iconProps: { iconName: 'Save' },
          children: t('translation:Ok', 'Ok'),
          title: hasChanges
            ? t('search:saveDateChanges', '')
            : t('search:noChanges', ''),
          disabled: !hasChanges || isEndBeforeStart || isMoreThanOneYear,
          styles: {
            root: {
              height: 'unset',
            },
          },
        }}
      />
      <ActionButton
        {...{
          children: t('search:Reset', 'Reset'),
          onClick: clear,
          iconProps: { iconName: 'Undo' },
          title: t('search:resetToCurrent', 'Reset to current dates'),
        }}
      />
      <ActionButton
        {...{
          key: 'reset',
          children: t('search:defaultDates', 'Default (last update cycle)'),
          title: t(
            'search:defaultDatesTitle',
            'Reset dates to the latest update cycle'
          ),
          iconProps: { iconName: 'ChromeClose' },
          onClick: resetToDefault,
        }}
      />
    </Stack>
  );
};
